import { getFlagUrl } from '@/lib/images'

import { PaymentRails } from '../constants'

import { DolarAppAvatar } from './DolarAppAvatar'

type Props = {
  paymentRails: PaymentRails
  className?: string
}

export const RecipientAccountAvatar = ({ paymentRails, className }: Props) => {
  switch (paymentRails) {
    case PaymentRails.MEX:
      return (
        <img src={getFlagUrl('mx')} className="size-3" alt="" aria-hidden />
      )

    case PaymentRails.USA:
      return (
        <img src={getFlagUrl('us')} className="size-3" alt="" aria-hidden />
      )

    case PaymentRails.DOLAR_APP:
      return <DolarAppAvatar className={className} />

    case PaymentRails.EU:
      return (
        <img src={getFlagUrl('eu')} className="size-3" alt="" aria-hidden />
      )

    default:
      return null
  }
}
